{
  "de": {
    "groupJoinForm": {
      "label": "8-stelliger Aktivierungscode",
      "placeholder": "Code eingeben...",
      "submit": "Lizenz aktivieren",
      "error": "Der eingegebene Code ist ungültig.",
      "invalidFormat": "Bitte gib einen gültigen 8-stelligen Code ein.",
      "alreadyMember": "Du bist bereits Mitglied dieser Gruppe."
    }
  }
}
